<template>
  <transition name="fade">
    <div class="modal-mask fixed inset-0 overflow-y-auto">
      <div class="static align-middle p-8 h-full">
        <div
          class="modal-container"
          v-click-outside="closeMe"
          :class="'modal-w-' + modalWidth">
          <slot name="header">Your awesome title goes here</slot>
          <slot name="body">And your content goes here</slot>
          <slot name="footer">You can also put some footer in here.<br><span @click="closeMe">Click here to close the modal</span>.</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { directive as onClickaway } from 'vue-clickaway';
  export default {
    name: 'the-modal',
    directives: { 'click-outside': onClickaway },
    props: {
      modalWidth: { type: String, default: 'medium' },
      closeable: { type: Boolean, default: true },
    },
    mounted (){
      document.body.addEventListener('keyup', this.escKeyUpFunction);
    },
    beforeDestroy() {
      document.body.removeEventListener('keyup', this.escKeyUpFunction);
    },
    methods: {
      closeMe() {
        if (this.closeable) {
          this.$emit('close');
        }
      },
      escKeyUpFunction(e) {
        if (e.keyCode === 27) {
          this.closeMe();
        }
      }
    }
  }
</script>